module.exports = __webpack_public_path__ + "static/media/tv.de4245db.svg";